// Create all stores
export default {
  session: require('./session').default,
  navigation: require('./navigation').default,
  contact: require('./contact').default,
  modal: require('./modal').default,
};
